var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1670_28891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1663 8.33398H22.2497C13.1247 8.33398 8.33301 13.1257 8.33301 22.209V30.1257C8.33301 39.209 13.1247 44.0007 22.208 44.0007H30.1247C39.208 44.0007 43.9997 39.209 43.9997 30.1257V22.209C44.0413 13.1257 39.2497 8.33398 30.1663 8.33398Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7975 8.33398H69.8809C60.7975 8.33398 56.0059 13.1257 56.0059 22.209V30.1257C56.0059 39.209 60.7975 44.0007 69.8809 44.0007H77.7975C86.8809 44.0007 91.6725 39.209 91.6725 30.1257V22.209C91.6725 13.1257 86.8809 8.33398 77.7975 8.33398Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7975 55.957H69.8809C60.7975 55.957 56.0059 60.7487 56.0059 69.832V77.7487C56.0059 86.832 60.7975 91.6237 69.8809 91.6237H77.7975C86.8809 91.6237 91.6725 86.832 91.6725 77.7487V69.832C91.6725 60.7487 86.8809 55.957 77.7975 55.957Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1663 55.957H22.2497C13.1247 55.957 8.33301 60.7487 8.33301 69.832V77.7487C8.33301 86.8737 13.1247 91.6654 22.208 91.6654H30.1247C39.208 91.6654 43.9997 86.8737 43.9997 77.7904V69.8737C44.0413 60.7487 39.2497 55.957 30.1663 55.957Z",
    fill: "none",
    stroke: "current",
    strokeWidth: 5.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_28891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.d2862e7f8b136c4cce83b7560233f346.svg";
export { ForwardRef as ReactComponent };